import { Mods, mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import { SsoPanel } from 'modules/auth';
import { font } from 'modules/styles';
import styled from 'styled-components';

export const Container = styled.div`
    min-height: 376px;
    padding: 40px 60px 50px;
    background-color: #fff;
    border-radius: 8px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        position: fixed;
        min-height: initial;
        max-width: initial;
        max-height: initial;
        width: 100vw;
        height: 100vh;
        height: 100dvh;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
        padding: 0;
        z-index: 1;
        border-radius: 0;
    }
`;

export const Switcher = styled.div`
    display: flex;
    width: 220px;
    height: 36px;
    margin: 0 auto;
    border-radius: 8px;
    overflow: hidden;
`;

export const SwitchButton = styled.button<StyledMods<Mods<'active'>>>`
    width: 50%;
    background-color: #eff0f0;
    text-align: center;
    cursor: pointer;
    ${font(14, '#000')};

    ${mods.active.true`
        background-color: #384650;
        ${font(14, '#fff')};
    `};
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        align-items: center;
        padding: 20px 15px;
    }
`;

export const Content = styled.div`
    flex: 1;
    margin-top: 40px;
    width: 100%;
    margin-top: 0;
`;

export const StyledSsoPanel = styled(SsoPanel)`
    width: 100%;
    margin-top: 0;
`;

export const SsoDelimiter = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    ${font(12, '#6c6a6a')};
    margin-top: 50px;
    margin-bottom: 20px;

    &:before,
    &:after {
        content: '';
        flex: 1 1;
        border-bottom: 1px solid #cacccd;
        margin: auto;
    }
    &:before {
        margin-right: 10px;
    }
    &:after {
        margin-left: 10px;
    }

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        margin-top: 30px;
    }
`;

export const MobileTitle = styled.div`
    ${font(16, '#36cf8a')};
`;
